<div class="login-container">
  <div class="login-form">
    <div class="card">
      <div class="card-header bg-orange text-center">
        <img src="assets/images/logo-mapoh.png" alt="Mapoh Logo" height="95">
      </div>
      <div class="card-body px-5">
        <h2 class="text-center mb-4">Bienvenido</h2>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="px-3">
          <!-- Mensaje de error -->
          <div *ngIf="error" class="alert alert-danger">
            {{ error }}
          </div>
          
          <!-- Campo email -->
          <div class="mb-4">
            <input 
              type="email" 
              id="email"
              formControlName="email"
              class="form-control custom-input" 
              placeholder="Correo electrónico"
              [ngClass]="{'is-invalid': loginForm.get('email')?.invalid && loginForm.get('email')?.touched}"
            >
            <div *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" class="invalid-feedback">
              <span *ngIf="loginForm.get('email')?.errors?.['required']">El correo electrónico es requerido.</span>
              <span *ngIf="loginForm.get('email')?.errors?.['email']">Ingrese un correo electrónico válido.</span>
            </div>
          </div>
          
          <!-- Campo password -->
          <div class="mb-4 position-relative">
            <input 
              [type]="showPassword ? 'text' : 'password'" 
              id="password"
              formControlName="password"
              class="form-control custom-input" 
              placeholder="Contraseña"
              [ngClass]="{'is-invalid': loginForm.get('password')?.invalid && loginForm.get('password')?.touched}"
            >
            <span class="password-toggle" (click)="togglePasswordVisibility()">
              <i class="bi" [ngClass]="{'bi-eye-fill': !showPassword, 'bi-eye-slash-fill': showPassword}"></i>
            </span>
            <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="invalid-feedback">
              La contraseña es requerida.
            </div>
          </div>
          
          <!-- Botón submit -->
          <div class="d-grid gap-2">
            <button 
              type="submit" 
              class="btn btn-primary btn-login mt-4" 
              [disabled]="loginForm.invalid || isSubmitting"
            >
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Iniciar Sesión
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
